import { render, staticRenderFns } from "./IbBrandLogo.vue?vue&type=template&id=2efa5810"
import script from "./IbBrandLogo.vue?vue&type=script&lang=js"
export * from "./IbBrandLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports